var map = {
	"./Adopt.vue": [
		"2b78",
		"chunk-1a03824b"
	],
	"./Airdrop.vue": [
		"6535",
		"chunk-3aafe6ec",
		"chunk-2d0cfa57"
	],
	"./AlpacaInfo.vue": [
		"5f1d",
		"chunk-2a3a8352",
		"chunk-208275f0"
	],
	"./Alpacas.vue": [
		"200b",
		"chunk-386989d1",
		"chunk-7df29160"
	],
	"./Bank.vue": [
		"ae2d",
		"chunk-0f42ba2a"
	],
	"./Breeding.vue": [
		"987b",
		"chunk-386989d1",
		"chunk-411be816"
	],
	"./Farm.vue": [
		"9b76",
		"chunk-386989d1",
		"chunk-2a3a8352",
		"chunk-764e796c",
		"chunk-124b985e"
	],
	"./FarmBSC.vue": [
		"ca60",
		"chunk-386989d1",
		"chunk-2a3a8352",
		"chunk-764e796c",
		"chunk-cfc7d82c"
	],
	"./Home.vue": [
		"bb51"
	],
	"./ScarfInfo.vue": [
		"9b9e",
		"chunk-53e82aec"
	],
	"./Scarves.vue": [
		"d9ad",
		"chunk-f9817a44"
	],
	"./Stake.vue": [
		"8502",
		"chunk-082b5fba"
	],
	"./TokenPresale.vue": [
		"e2cb",
		"chunk-5100eb64"
	],
	"./TokenPresaleWL.vue": [
		"e0f5",
		"chunk-5dfef95c"
	],
	"./Trade.vue": [
		"6e13",
		"chunk-386989d1",
		"chunk-3aafe6ec",
		"chunk-25563e7b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;